<div class="overlay-spinner" *ngIf="LoaderStatus">
  <div class="d-flex justify-content-center">
    <div class="spinner-border text-warning" style="width: 3rem; height: 3rem; " role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
</div>
<app-alert [Type]="AlertType" [View]="AlertStatus" [Message]="AlertMessage"></app-alert>
<div class="mx-5 pb-5">
  <app-pages-header></app-pages-header>
  <div class="bg-white mx-1 bottom-page-shadow rounded-bottom-extra">
    <div class="row  ps-3">
      <div class="col pt-3 ">
        <p> <span class="fw-bold">Integrasi</span> {{ integrasiCkmTitle }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col pt-3 mx-5 ">
        <p class="text-muted">Sila masukkan TIN, Tahun Pelupusan dan tekan butang Hantar</p>
      </div>
    </div>
    <div class="row pb-5">
      <div class="col-1 ms-5">
        <label>TIN : </label>
      </div>
      <div class="col-2 ms-5">
        <select class="form-select border-0 shadow" aria-label="Search type" [(ngModel)]="SearchTypeInput" [ngModelOptions]="{standalone: true}" (change)="onChangeIDType()">
          <option value="" selected>Jenis Carian</option>
          <option value="6">TIN (Selain No. Majikan)</option>
          <option value="7">TIN (Majikan)</option>
          <!--<option value="6">No. Pendaftaran (ROC)</option>-->
        </select>
      </div>
      <div class="col-2 ms-2">
        <input type="number" [(ngModel)]="TINInput" [ngModelOptions]="{standalone: true}" class="form-control border-0 shadow">
      </div>
      <div class="col-4">
        <div class="btn-toolbar d-flex justify-content-center">
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2" role="button" (click)="Submit(SearchTypeInput,TINInput)">Hantar</button>
          </div>
          <div class="me-2">
            <button type="button" class="btn submit-button border-0 shadow rounded-2 bg-white" role="button" (click)="Semula()">Semula</button>
          </div>
        </div>
      </div>
    </div>

    <div class="accordion px-5 pb-5" id="resultAcordion" *ngIf="SearchStatus">
      <div class="accordion-item border-0">
        <h2 class="accordion-header m-0" id="headingOne">
          <button class="accordion-button primary-colour text-black shadow rounded-top-extra" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
            Butiran Carian
          </button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse show bottom-page-shadow default-content-bg-colour rounded-bottom-extra" aria-labelledby="headingOne" data-bs-parent="#resultAcordion">
          <div class="accordion-body">
            <div class="row">
              <div class="col-2">
                <p>Pembayar Cukai</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-5">
                <p><strong>{{TaxpNameView}}</strong></p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <p>TIN</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-1">
                <p><strong>{{TINView}}</strong></p>
              </div>
            </div>

            <div class="row">
              <div class="col-2">
                <p>LHDNM / Cawangan Khas</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col">
                <p><strong>{{BranchNameView}}</strong></p>
              </div>
            </div>

            <div class="pt-2">
              <p>Senarai Borang</p>
              <!--<input #input type="text" (keyup)="applyFilter($event)" class="form-control w-25 mb-2 border-0 shadow" placeholder="Carian" aria-label="Carian" aria-describedby="basic-addon1">-->
            </div>
            <div>
              <table class="table table-borderless w-100">
                <thead>
                  <tr class="primary-colour text-center">
                    <th scope="col">Jenis Borang</th>
                    <th scope="col" *ngIf="YearAssessmentRegisterStatus">Tahun Taksiran</th>
                    <th scope="col">Ejen Cukai</th>
                    <th scope="col">Tindakan</th>
                  </tr>
                </thead>
                <tbody class="bg-white text-center pt-1">
                  <tr>
                    <td>
                      <select class="form-select border-0 shadow" [(ngModel)]="FormTypeInput" [ngModelOptions]="{standalone: true}" (change)="ChangeFormTypeRegister(FormTypeInput)">
                        <option value="">Jenis Borang</option>
                        <option *ngFor="let res of FormTypeList" [value]="res.formName">e-{{res.formName}}</option>
                      </select>
                    </td>
                    <td *ngIf="YearAssessmentRegisterStatus">
                      <ng-container>
                        <select class="form-select border-0 shadow" [(ngModel)]="YearAssessmentInput" [ngModelOptions]="{standalone: true}">
                          <option value="">Tahun Taksiran</option>
                          <option *ngFor="let res of YearAssessmentList" [value]="res">{{res}}</option>
                        </select>
                      </ng-container>
                    </td>
                    <td>
                      <div>
                        <select class="form-select border-0 shadow" [(ngModel)]="AgentInput" [ngModelOptions]="{standalone: true}">
                          <option value="">Ejen Cukai</option>
                          <option *ngFor="let res of AgentList" [value]="res.taxAgentID">{{res.taxAgentName}}</option>
                        </select>
                      </div>
                    </td>
                    <td>
                      <div class="d-flex justify-content-center">
                        <div class="btn-toolbar">
                          <div class="me-2">
                            <button type="button" class="btn sec-button border-0 shadow rounded-2" role="button" (click)="Login(FormTypeInput,TINView,AgentInput,YearAssessmentInput)">Login</button>
                          </div>
                          <div class="me-2">
                            <button type="button" class="btn sec-button border-0 shadow rounded-2" data-bs-toggle="modal" data-bs-target="#semakanModal" role="button">Semakan</button>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>


<!-- CKM Acknowledgement Modal -->
<div class="modal fade" id="semakanModal" tabindex="-1" aria-labelledby="semakanModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
    <div class="modal-content pb-5" style="background-color: #E8E8E8 !important;">
      <div class="modal-body">
        <div class="d-flex justify-content-end align-items-end pb-3">
          <button class="btn" data-bs-dismiss="modal"><i class="bi bi-x-square-fill"></i></button>
        </div>
        <div class="row rounded-top-extra primary-colour shadow mx-3">
          <div class="col pt-2">
            <p>Semakan pengesahan</p>
          </div>
        </div>
        <div class="row rounded-bottom-extra shadow mx-3" style="background-color: #F5F5F5 !important;">
          <div class="col m-3">
            <div class="row py-5">
              <div class="col-3">
                <p>Tahun Taksiran</p>
              </div>
              <div class="col-1">
                <p class="text-end">:</p>
              </div>
              <div class="col-4">
                <select class="form-select border-0 shadow" [(ngModel)]="AcknowledgementYearAssessmentInput" [ngModelOptions]="{standalone: true}">
                  <option value="">Tahun</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col d-flex justify-content-end align-items-end">
                <div class="btn-toolbar">
                  <div class="me-2">
                    <button data-bs-dismiss="modal" type="button" class="btn submit-primary-button border-0 shadow rounded-2" role="button" (click)="GetAcknowledment(FormTypeInput,AcknowledgementYearAssessmentInput,TINView)">Hantar</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

